import React from 'react'
import { Helmet } from 'react-helmet-async'
import { Layout } from 'antd'
import { HeaderSection } from 'app/components/Layouts'
import { useLocation } from 'react-router-dom'
import styled from 'styled-components'
import ModernTabNavigation from '../../components/ModernTabNavigation'
import { TicketTable } from './TicketTable'

const StyledLayout = styled(Layout)`
  background: #f8f9fa;
  min-height: 100vh;
`

const StyledContent = styled(Layout.Content)`
  padding: 0 50px 20px;

  @media (max-width: 768px) {
    padding: 0 5px 20px;
  }
`
export const AdminTicketPage = () => {
	const location = useLocation()
	const url = location.pathname

	const items = [
		{
			title: '전체문의',
			link: '/ticket',
		},
		{
			title: '대기중',
			link: '/ticket/0',
		},
		{
			title: '검토중',
			link: '/ticket/1',
		},
		{
			title: '완료',
			link: '/ticket/2',
		},
	]

	const renderContent = () => {
		switch (url) {
			case '/ticket':
				return <TicketTable title={'전체문의'} type={'*'} />
			case '/ticket/0':
				return <TicketTable title={'대기중'} type={0} />
			case '/ticket/1':
				return <TicketTable title={'검토중'} type={1} />
			case '/ticket/2':
				return <TicketTable title={'완료'} type={2} />
			default:
				return <TicketTable title={'전체문의'} type={'*'} />
		}
	}

	return (
		<StyledLayout>
			<Helmet>
				<title>ADMIN - 사용자문의</title>
			</Helmet>
			<HeaderSection />
			<ModernTabNavigation items={items} />
			<StyledContent>
				{renderContent()}
			</StyledContent>
		</StyledLayout>
	)
}
